/** Niche colour tokens from cursor-handoff.md — applied dynamically on profile pages. */

export const NICHE_THEME_VARS = {
  wellness: {
    "--niche": "#5C8B6E",
    "--niche-light": "#EAF2ED",
    "--niche-mid": "#4A7A5C",
    "--niche-glow": "rgba(92,139,110,0.2)",
  },
  beauty: {
    "--niche": "#8B5C8B",
    "--niche-light": "#F2EAF2",
    "--niche-mid": "#7A4A7A",
    "--niche-glow": "rgba(139,92,139,0.2)",
  },
  food: {
    "--niche": "#7A6B3A",
    "--niche-light": "#F5F0E0",
    "--niche-mid": "#6A5A2A",
    "--niche-glow": "rgba(122,107,58,0.2)",
  },
  fitness: {
    "--niche": "#B55A1A",
    "--niche-light": "#FBEEE4",
    "--niche-mid": "#A04A0A",
    "--niche-glow": "rgba(181,90,26,0.2)",
  },
  auto: {
    "--niche": "#3A5A7A",
    "--niche-light": "#E4EDF5",
    "--niche-mid": "#2A4A6A",
    "--niche-glow": "rgba(58,90,122,0.2)",
  },
  mind: {
    "--niche": "#4A4A8A",
    "--niche-light": "#EEEEF8",
    "--niche-mid": "#3A3A7A",
    "--niche-glow": "rgba(74,74,138,0.2)",
  },
  arts: {
    "--niche": "#9B3A3A",
    "--niche-light": "#F8EAEA",
    "--niche-mid": "#8A2A2A",
    "--niche-glow": "rgba(155,58,58,0.2)",
  },
  independent: {
    "--niche": "#C4790A",
    "--niche-light": "#FDF3E0",
    "--niche-mid": "#A86208",
    "--niche-glow": "rgba(196,121,10,0.25)",
  },
};

export function getNicheThemeStyle(nicheKey) {
  const vars = NICHE_THEME_VARS[nicheKey] || NICHE_THEME_VARS.independent;
  return vars;
}

export function nicheThemeClassName(nicheKey) {
  return `cp-niche-${nicheKey || "independent"}`;
}
